import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function AdminScraper() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [running, setRunning] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(API_URL + '/api/admin/scraper-logs', {
        headers: { Authorization: 'Bearer ' + token }
      });
      setData(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const runScraper = async () => {
    try {
      setRunning(true);
      await axios.post(API_URL + '/api/admin/trigger-scraper', {}, {
        headers: { Authorization: 'Bearer ' + token }
      });
      alert('Scraper triggered!');
    } catch (err) {
      alert('Failed');
    } finally {
      setRunning(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  const stats = data ? data.scraper_stats : null;
  const jobs = data ? data.recent_jobs : [];

  return (
    <div className="min-h-screen bg-slate-900">
      <div className="bg-slate-800 border-b border-slate-700">
        <div className="max-w-7xl mx-auto px-4 py-6 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <button onClick={function(){ navigate('/admin'); }} className="text-slate-400 hover:text-white">
              Back
            </button>
            <h1 className="text-2xl font-bold text-white">Scraper Logs</h1>
          </div>
          <button 
            onClick={runScraper}
            disabled={running}
            className="px-4 py-2 bg-green-600 text-white rounded-lg disabled:opacity-50"
          >
            {running ? 'Running...' : 'Run Scraper'}
          </button>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-slate-800 rounded-xl border border-slate-700 p-6">
            <p className="text-slate-400 text-sm">Last Run</p>
            <p className="text-white">{stats && stats.last_run ? new Date(stats.last_run).toLocaleString() : 'Never'}</p>
          </div>
          <div className="bg-slate-800 rounded-xl border border-slate-700 p-6">
            <p className="text-slate-400 text-sm">Alerts Processed</p>
            <p className="text-white text-xl">{stats ? stats.alerts_processed : 0}</p>
          </div>
          <div className="bg-slate-800 rounded-xl border border-slate-700 p-6">
            <p className="text-slate-400 text-sm">New Jobs</p>
            <p className="text-white text-xl">{stats ? stats.new_jobs : 0}</p>
          </div>
          <div className="bg-slate-800 rounded-xl border border-slate-700 p-6">
            <p className="text-slate-400 text-sm">Matches Created</p>
            <p className="text-white text-xl">{stats ? stats.matches_created : 0}</p>
          </div>
        </div>

        <h2 className="text-lg font-semibold text-white mb-4">Recent Jobs</h2>
        <div className="bg-slate-800 rounded-xl border border-slate-700 divide-y divide-slate-700/50 max-h-96 overflow-y-auto">
          {jobs.map(function(job, i) {
            return (
              <div key={i} className="p-4">
                <p className="text-white">{job.title}</p>
                <p className="text-slate-400 text-sm">{job.employer}</p>
                <p className="text-slate-500 text-xs">{new Date(job.scraped_at).toLocaleString()}</p>
              </div>
            );
          })}
          {jobs.length === 0 && (
            <p className="p-8 text-center text-slate-500">No jobs scraped yet</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminScraper;
